const ACTION_OPTIONS = {
    option1: 'immediateHelp',
    option2: 'travelCountryMedicalCareInfo',
    option3: 'destinationCountryMedicalCareInfo'
};

export default ACTION_OPTIONS;
